import React, { useState } from "react";
import { useParams } from "react-router-dom";

const SendEmailForm = () => {
  const { id } = useParams();
  console.log("✅ Renderizando SendEmailForm para ID:", id);
  const [asunto, setAsunto] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [imagenUrl, setImagenUrl] = useState("");
  const [imagen, setImagen] = useState(null); // Guardamos el archivo de imagen

  // Manejar la selección de la imagen
  const handleImageChange = (e) => {
    setImagen(e.target.files[0]);
  };

  // Subir la imagen al servidor
  const handleImageUpload = async () => {
    if (!imagen) {
      console.error("No se ha seleccionado ninguna imagen");
      return;
    }
  
    const formData = new FormData();
    formData.append("imagen", imagen); // Usamos "imagen" en lugar de "selectedFile"
    formData.append("tipo", "producto"); // O "promocion", según el caso
  
    try {
      const response = await fetch(
        "https://panelcomerciantes.lagora.chat/api/upload.php",
        {
          method: "POST",
          body: formData, // Importante: NO agregar headers aquí
        }
      );
  
      const result = await response.json();
  
      if (result.success) {
        setImagenUrl(result.url); // Guardamos la URL de la imagen subida
      } else {
        console.error("Error al subir imagen:", result.message);
      }
    } catch (error) {
      console.error("Error de red:", error);
    }
  };
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");

    const data = { id, asunto, mensaje };

    // Si hay imagen, la agregamos
    if (imagenUrl.trim() !== "") {
      data.imagen_url = imagenUrl;
    }

    try {
      const response = await fetch(
        "https://panelcomerciantes.lagora.chat/api/sendEmailToComerciante.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (result.success) {
        setSuccessMessage("📧 Correo enviado con éxito");
        setAsunto("");
        setMensaje("");
        setImagen(null);
        setImagenUrl("");
      } else {
        setError(result.message || "Error desconocido al enviar el correo");
      }
    } catch (error) {
      console.error("Error de red:", error);
      setError("No se pudo conectar con el servidor. Intenta nuevamente.");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Asunto:
        <input type="text" value={asunto} onChange={(e) => setAsunto(e.target.value)} required />
      </label>
      <br />
      <label>
        Mensaje:
        <textarea value={mensaje} onChange={(e) => setMensaje(e.target.value)} required />
      </label>
      <br />
      <label>
        Subir imagen (opcional):
        <input type="file" accept="image/*" onChange={handleImageChange} />
        <button type="button" onClick={handleImageUpload} disabled={!imagen}>
          Subir imagen
        </button>
      </label>
      <br />
      {imagenUrl && <p>📸 Imagen subida: <a href={imagenUrl} target="_blank" rel="noopener noreferrer">{imagenUrl}</a></p>}
      <br />
      <button type="submit" disabled={loading}>
        {loading ? "Enviando..." : "Enviar Email"}
      </button>
    </form>
  );
};

export default SendEmailForm;
